import * as Api from '@ViewModels';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components-v2/Select';
import { FormFieldWrapper } from '../../shared/components/FormFieldWrapper';
import { styleSheet } from '../styles';
import { getGuestEmailMode } from '../../../../../surveys/containers/SurveyResponses/EventRegistration/components/EventSurvey/EventSurveyForm/utils';
import { EventRegistrationFormData } from '../utils';

const guestEmailModeOptions = [
	{ value: Api.GuestEmailMode.Off, label: "Don't ask" },
	{ value: Api.GuestEmailMode.Optional, label: 'Optional' },
	{ value: Api.GuestEmailMode.Required, label: 'Required' },
];

export const GuestEmailModeField = () => {
	const { control, watch } = useFormContext<EventRegistrationFormData>();
	const isPaidEvent = watch('isPaidEvent');
	const isRsvpEnabled = watch('enableRequestAttendeesToRSVP');

	return (
		<FormFieldWrapper
			name='guestEmailMode'
			control={control}
			title='Guest Email Addresses'
			description='Guests who give an email are added as contacts and can receive follow-ups'
			controllerWrapperStyles={[styleSheet.controllerWrapper]}
		>
			{({ value, onChange }) => {
				const selectedMode = getGuestEmailMode(value, isPaidEvent);
				return (
					<Select
						value={selectedMode}
						onValueChange={val => onChange(val as Api.GuestEmailMode)}
						disabled={!isRsvpEnabled}
					>
						<SelectTrigger id='guest-email-mode-select'>
							<SelectValue>{guestEmailModeOptions.find(option => option.value === selectedMode)?.label}</SelectValue>
						</SelectTrigger>
						<SelectContent>
							{guestEmailModeOptions.map(option => (
								<SelectItem key={option.value} value={option.value}>
									{option.label}
								</SelectItem>
							))}
						</SelectContent>
					</Select>
				);
			}}
		</FormFieldWrapper>
	);
};
